import { defineStore } from 'pinia';
import { StoreId } from '@/modules/common/enums/store-id.enum.ts';
import { SystemApi } from '@/modules/core/api/system.api.ts';
import type { Access } from '@/modules/common/enums/access.enum.ts';

interface State {
  list: Access[] | null;
}

export const useAccessStore = defineStore(StoreId.Access, {
  state: (): State => ({
    list: null,
  }),
  getters: {
    has: (state) => (access: Access) => !!state.list?.includes(access),
    isDefined: (state) => !!state.list,
  },
  actions: {
    async fetch() {
      this.list = await SystemApi.getAccessList();
    },
  },
  persist: true,
});
